<dx-data-grid
  class="dashboard-grid"
  [dataSource]="data[0].data"
  [showRowLines]="true"
  [rowAlternationEnabled]="false"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
  [showBorders]="false"
  (onToolbarPreparing)="onToolbarPreparing($event)">
  <dxi-column
    caption="Tracteur"
    dataField="tractor">
  </dxi-column>

  <dxi-column
    sortOrder="asc"
    caption="Distance"
    dataField="distance"
    format="#0.## Km">
  </dxi-column>

  <dxi-column
    caption="Parcelle"
    dataField="field">
  </dxi-column>
</dx-data-grid>

